import brand from "./config.js";

/** Trackers never inherit. Contact identity falls back to `apps.main`. */
export function getBrandApp(appId = "main") {
  const apps = brand.apps || {};
  const main = apps.main || {};
  if (appId === "main") return main;

  const app = apps[appId] || {};
  return {
    emails: app.emails || main.emails || {},
    mailgun: app.mailgun || main.mailgun || {},
    mailFromName: app.mailFromName || main.mailFromName || "",
    smsFrom: app.smsFrom || main.smsFrom || "",
    supportTelegramBot:
      app.supportTelegramBot !== undefined
        ? app.supportTelegramBot
        : main.supportTelegramBot || "",
    tawkEmbedUrl: app.tawkEmbedUrl || "",
    yandexMetrikaId: app.yandexMetrikaId || "",
    gtmContainerId: app.gtmContainerId || "",
    gaMeasurementId: app.gaMeasurementId || "",
  };
}

export function tawkEmbedUrl(appId = "main") {
  return String(getBrandApp(appId).tawkEmbedUrl || "").trim();
}

export function yandexMetrikaId(appId = "main") {
  return String(getBrandApp(appId).yandexMetrikaId || "").replace(/\D/g, "");
}

export function gtmContainerId(appId = "main") {
  return String(getBrandApp(appId).gtmContainerId || "").trim();
}

export function gaMeasurementId(appId = "main") {
  return String(getBrandApp(appId).gaMeasurementId || "").trim();
}

export function supportTelegramUrl(appId = "main") {
  const username = String(getBrandApp(appId).supportTelegramBot || "")
    .replace(/^@/, "")
    .trim();
  return username ? `https://t.me/${username}` : null;
}

export function affilateContactEmail() {
  const emails = getBrandApp("affilate").emails || {};
  return String(emails.contact || emails.support || "").trim();
}

export function affilateContactTelegram() {
  const url = supportTelegramUrl("affilate");
  if (!url) return null;
  return { url, handle: `@${url.replace(/^https:\/\/t\.me\//, "")}` };
}

export function casinoSiteUrl() {
  const frontend = brand.defaultPublicUrls?.frontend;
  if (frontend) return String(frontend).replace(/\/$/, "");
  const host = String(brand.siteDomain || "").replace(/^www\./, "");
  return host ? `https://${host}` : "";
}

export function installTawk(appId = "main") {
  if (typeof document === "undefined") return;
  const src = tawkEmbedUrl(appId);
  if (!src) return;
  if (document.querySelector(`script[src="${src}"]`)) return;

  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_API.onBeforeLoad = function () {
    if (window.innerWidth < 576) {
      window.Tawk_API.hideWidget();
    }
  };
  window.Tawk_LoadStart = new Date();

  const script = document.createElement("script");
  script.defer = true;
  script.src = src;
  script.charset = "UTF-8";
  script.setAttribute("crossorigin", "*");
  document.head.appendChild(script);
}

export function installYandexMetrika(appId = "main") {
  if (typeof document === "undefined") return;
  const id = yandexMetrikaId(appId);
  if (!id) return;

  const src = `https://mc.yandex.ru/metrika/tag.js?id=${id}`;
  if (document.querySelector(`script[src="${src}"]`)) return;

  window.ym =
    window.ym ||
    function () {
      (window.ym.a = window.ym.a || []).push(arguments);
    };
  window.ym.l = Date.now();

  const script = document.createElement("script");
  script.async = true;
  script.src = src;
  document.head.appendChild(script);

  window.ym(Number(id), "init", {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: "dataLayer",
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

export function installGtm(appId = "main") {
  if (typeof document === "undefined") return;
  const id = gtmContainerId(appId);
  if (!id) return;
  const src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  if (document.querySelector(`script[src="${src}"]`)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

export function installGtag(appId = "main") {
  if (typeof document === "undefined") return;
  const id = gaMeasurementId(appId);
  if (!id) return;
  const src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  if (document.querySelector(`script[src="${src}"]`)) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };

  const script = document.createElement("script");
  script.async = true;
  script.src = src;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", id);
}
